"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactApollo = require("react-apollo");

var _reactSizeme = require("react-sizeme");

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _commonReact = require("@devsta/common-react");

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

var _ManageSubscription = _interopRequireDefault(require("../components/ManageSubscription"));

var _api = require("../api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ManageSubscriptionContainer(_ref) {
  var history = _ref.history;
  return _react.default.createElement(_reactApollo.ApolloConsumer, null, function (apolloClient) {
    return _react.default.createElement(_commonReact.AuthorisationConsumer, null, function (_ref2) {
      var _ref2$selectedOrganis = _ref2.selectedOrganisation,
          organisationId = _ref2$selectedOrganis.organisationId,
          name = _ref2$selectedOrganis.name,
          permissions = _ref2$selectedOrganis.permissions,
          billingEntityCode = _ref2$selectedOrganis.billingEntityCode,
          includedAddonTypes = _ref2$selectedOrganis.includedAddonTypes;
      return _react.default.createElement(_commonReact.RequestProvider, {
        requests: {
          getOrganisation: (0, _api.getOrganisationQuery)(organisationId),
          getTeams: (0, _api.getTeamsQuery)(organisationId)
        }
      }, function (_ref3) {
        var getOrganisation = _ref3.getOrganisation,
            getTeams = _ref3.getTeams;
        return _react.default.createElement(_reactSizeme.SizeMe, null, function (_ref4) {
          var size = _ref4.size;
          return _react.default.createElement(_commonReact.AddonsProvider, {
            billingEntityCode: billingEntityCode,
            includedAddons: includedAddonTypes
          }, _react.default.createElement(_ManageSubscription.default, {
            apolloClient: apolloClient,
            containerSize: size,
            history: history,
            organisationId: organisationId,
            name: name,
            permissions: permissions,
            getOrganisation: getOrganisation,
            getTeams: getTeams
          }));
        });
      });
    });
  });
}

var _default = (0, _withBasedRouter.default)(_basePath.default, ManageSubscriptionContainer);

exports.default = _default;